<ml-mdm-command-spinner [commandProgress]="commandProgress$"
                        [small]="true"
                        [direction]="'left'">
  <button [ngClass]="class()"
          (click)="clearPasscode()"
          [class.disabled]="!enabled">
    <ng-content></ng-content>
  </button>
</ml-mdm-command-spinner>